import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setActiveReportType,
    updateFilters,
    resetFilters,
    setReportData,
    setLoading,
    setError,
    setExporting,
    clearAllReports,
    clearReportData,
} from "../../../store/reports/reportsSlice";

const mapStateToProps = (state) => {
    return {
        // Reports state
        activeReportType: state.reports.activeReportType,
        filters: state.reports.filters,
        reportData: state.reports.reportData,
        loading: state.reports.loading,
        errors: state.reports.errors,
        exporting: state.reports.exporting,
    };
};

const mapDispatch = {
    setActiveReportType,
    updateFilters,
    resetFilters,
    setReportData,
    setLoading,
    setError,
    setExporting,
    clearAllReports,
    clearReportData,
};

const mapDispatchToProps = (dispatch) => bindActionCreators(mapDispatch, dispatch);

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
